import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES].GET_CUSTOM_GEO_ZONES_CATEGORIES]: {
		url: '/company/:companyId/custom_geo_zone_categories/'
	},
	[ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES].GET_CUSTOM_GEO_ZONES_CATEGORY]: {
		url: '/company/:companyId/custom_geo_zone_categories/:customGeoZonesCategoryId/'
	},
	[ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES].CREATE_CUSTOM_GEO_ZONES_CATEGORY]: {
		url: '/company/:companyId/custom_geo_zone_categories/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES].PUT_CUSTOM_GEO_ZONES_CATEGORY]: {
		url: '/company/:companyId/custom_geo_zone_categories/:customGeoZonesCategoryId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES].PATCH_CUSTOM_GEO_ZONES_CATEGORY]: {
		url: '/company/:companyId/custom_geo_zone_categories/:customGeoZonesCategoryId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES].DELETE_CUSTOM_GEO_ZONES_CATEGORY]: {
		url: '/company/:companyId/custom_geo_zone_categories/:customGeoZonesCategoryId/',
		requestOptions: {
			method: 'DELETE',
		},
	}
}